// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-icon {
  border: 0;
  background: transparent;
  font-size: 26px;
}

.btn-icon:hover {
  color: var(--color-principal);
  font-size: 26px;
  font-weight: bolder;
}

.cart-modal {
  position: fixed;
  z-index: 999;
  top: 145px;
  right: 20px;
}

.input-finalizar {
  width: 50%;
}

@media (min-width: 320px) and (max-width: 480px), (min-width: 481px) and (max-width: 768px) {
  .row {
    flex-direction: column;
    align-items: center;
  }
  .col-8 {
    width: 90%;
    text-align: center;
  }
  .col-4 {
    width: 90%;
  }
  .input-finalizar {
    width: 100%;
  }
}
.modal {
  z-index: 9999;
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 0;
  background: rgba(255, 230, 0, 0.144);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modalError {
  height: 400px;
  width: 600px;
  background-color: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/finalizar/finalizar.component.scss","webpack://./../../Universo%20Tunning/ecommerce/src/app/pages/finalizar/finalizar.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,uBAAA;EACA,eAAA;ACCF;;ADCA;EACE,6BAAA;EACA,eAAA;EACA,mBAAA;ACEF;;ADCA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;ACEF;;ADAA;EACE,UAAA;ACGF;;ADAA;EAEE;IACE,sBAAA;IACA,mBAAA;ECEF;EDAA;IACE,UAAA;IACA,kBAAA;ECEF;EDCA;IACE,UAAA;ECCF;EDCA;IACE,WAAA;ECCF;AACF;ADEA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,MAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACAF;;ADGA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;ACAF","sourcesContent":[".btn-icon {\n  border: 0;\n  background: transparent;\n  font-size: 26px;\n}\n.btn-icon:hover {\n  color: var(--color-principal);\n  font-size: 26px;\n  font-weight: bolder;\n}\n\n.cart-modal {\n  position: fixed;\n  z-index: 999;\n  top: 145px;\n  right: 20px;\n}\n.input-finalizar {\n  width: 50%;\n}\n\n@media (min-width: 320px) and (max-width: 480px),\n  (min-width: 481px) and (max-width: 768px) {\n  .row {\n    flex-direction: column;\n    align-items: center;\n  }\n  .col-8 {\n    width: 90%;\n    text-align: center;\n  }\n\n  .col-4 {\n    width: 90%;\n  }\n  .input-finalizar {\n    width: 100%;\n  }\n}\n\n.modal {\n  z-index: 9999;\n  position: absolute;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  background: rgba(255, 230, 0, 0.144);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modalError{\n  height: 400px;\n  width: 600px;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-evenly;\n}\n",".btn-icon {\n  border: 0;\n  background: transparent;\n  font-size: 26px;\n}\n\n.btn-icon:hover {\n  color: var(--color-principal);\n  font-size: 26px;\n  font-weight: bolder;\n}\n\n.cart-modal {\n  position: fixed;\n  z-index: 999;\n  top: 145px;\n  right: 20px;\n}\n\n.input-finalizar {\n  width: 50%;\n}\n\n@media (min-width: 320px) and (max-width: 480px), (min-width: 481px) and (max-width: 768px) {\n  .row {\n    flex-direction: column;\n    align-items: center;\n  }\n  .col-8 {\n    width: 90%;\n    text-align: center;\n  }\n  .col-4 {\n    width: 90%;\n  }\n  .input-finalizar {\n    width: 100%;\n  }\n}\n.modal {\n  z-index: 9999;\n  position: absolute;\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  background: rgba(255, 230, 0, 0.144);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modalError {\n  height: 400px;\n  width: 600px;\n  background-color: white;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-evenly;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
